import { get } from '@bigyouth/base'

export default {
  name: 'form-addresses',

  ui: {
    addAdresses: '[js-add-address]',
    addressesList: '[js-addresses-list]',
    btnShowNewAddress: '[js-show-new-address]',
    btnHideNewAddress: '[js-hide-new-address]',
    'editAdresses[]': '[js-edit-addresses]',
    'deleteAdresses[]': '[js-delete-address]',
    'btnShowEditAddress[]': '[js-show-edit-address]',
    'btnHideEditAddress[]': '[js-hide-edit-address]',
  },

  events: [
    {
      target: 'btnShowNewAddress',
      on: 'click',
      handle: 'showNewAddress',
    },
    {
      target: 'btnHideNewAddress',
      on: 'click',
      handle: 'hideNewAddress',
    },
    {
      target: 'btnShowEditAddress',
      on: 'click',
      handle ({ target }) {
        this.showEditAddress(target)
      },
    },
    {
      target: 'btnHideEditAddress',
      on: 'click',
      handle: 'hideEditAddress',
    },
    {
      target: 'deleteAdresses',
      on: 'click',
      handle ({ target }) {
        this.deleteAddress(target)
      },
    },
  ],

  componentDidMount () {
  },

  showNewAddress () {
    this.ui.addAdresses.classList.remove('hidden')
    this.ui.addressesList.classList.add('hidden')
    this.scrollIt(get('.js-top-scroll').offsetTop)
  },

  hideNewAddress () {
    this.ui.addAdresses.classList.add('hidden')
    this.ui.addressesList.classList.remove('hidden')
    this.scrollIt(get('.js-top-scroll').offsetTop)
  },

  showEditAddress (el) {
    const id = el.getAttribute('data-target-id')

    get('[data-id="' + id + '"]').classList.remove('hidden')
    this.ui.addressesList.classList.add('hidden')
    this.scrollIt(get('.js-top-scroll').offsetTop)
  },

  hideEditAddress (e) {
    e.preventDefault()

    this.ui.editAdresses.forEach((address) => {
      address.classList.add('hidden')
    })

    this.ui.addressesList.classList.remove('hidden')
    this.scrollIt(get('.js-top-scroll').offsetTop)
  },

  deleteAddress (e) {
    e.parentNode.parentNode.querySelector('form').submit()
  },

  scrollIt (destination, duration = 200, easing = 'linear', callback) {
    const easings = {
      linear (t) {
        return t
      },
      easeInQuad (t) {
        return t * t
      },
      easeOutQuad (t) {
        return t * (2 - t)
      },
      easeInOutQuad (t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
      },
      easeInCubic (t) {
        return t * t * t
      },
      easeOutCubic (t) {
        return (--t) * t * t + 1
      },
      easeInOutCubic (t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
      },
      easeInQuart (t) {
        return t * t * t * t
      },
      easeOutQuart (t) {
        return 1 - (--t) * t * t * t
      },
      easeInOutQuart (t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t
      },
      easeInQuint (t) {
        return t * t * t * t * t
      },
      easeOutQuint (t) {
        return 1 + (--t) * t * t * t * t
      },
      easeInOutQuint (t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t
      },
    }

    const start = window.pageYOffset
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime()

    const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight)
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight
    const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop
    const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset)

    if ('requestAnimationFrame' in window === false) {
      window.scroll(0, destinationOffsetToScroll)
      if (callback) {
        callback()
      }
      return
    }

    function scroll () {
      const now = 'now' in window.performance ? performance.now() : new Date().getTime()
      const time = Math.min(1, ((now - startTime) / duration))
      const timeFunction = easings[easing](time)
      window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start))

      if (window.pageYOffset === destinationOffsetToScroll) {
        if (callback) {
          callback()
        }
        return
      }

      requestAnimationFrame(scroll)
    }

    scroll()
  },
}
